import React from "react";
import PropTypes from "prop-types";

const Label = function ({with_label = false, label = 'Date created'}) {
    if (with_label) {
        return <label>{label}</label>;
    }

    return null;
}

Label.propTypes = {
    with_label: PropTypes.bool,
    label: PropTypes.string
}

export default Label;
